exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".toggleSwitch[data-v-0a478836]{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row}", "", {"version":3,"sources":["/home/runner/work/KeepNeyeVue/KeepNeyeVue/src/components/view/Dev.vue"],"names":[],"mappings":"AACA,+BACE,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,kBAAoB,CACzB","file":"Dev.vue","sourcesContent":["\n.toggleSwitch[data-v-0a478836] {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n"],"sourceRoot":""}]);

// exports
